import dayjs from 'dayjs';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import OptimizeTag from '@/components/meta/OptimizeTag';
import LpTemplate from '@/components/templates/Lp/Entry';
import { INVITER_PARAM_KEY } from '@/config/constants/query';
import useClock from '@/hooks/date/useClock';
import { setInviterCookie } from '@/lib/invitation';

const LpPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviter = queryParams.get(INVITER_PARAM_KEY);

  if (inviter) {
    setInviterCookie(inviter);
  }

  const currentTime = useClock();
  const isMissionUpdated = React.useMemo(() => {
    const since = dayjs(import.meta.env.VITE_MISSION_UPDATE_SINCE);

    if (since) {
      return since.unix() < currentTime.unix();
    }

    return false;
  }, [currentTime]);

  const title = `新規登録＋ミッション達成で最大${
    isMissionUpdated ? '4,000' : '2,500'
  }円分ポイントプレゼント！`;

  return (
    <>
      <Helmet
        meta={{
          title,
          description: `新規登録＋ミッション達成で最大${
            isMissionUpdated ? '4,000' : '2,500'
          }円分ポイントプレゼント！%s`,
          keywords: `新規登録,ポイントプレゼント,%s`,
          'og:image': `${import.meta.env.VITE_BASE_URL}/images/ogp/lp_ogp_${
            isMissionUpdated ? '4000' : '2500'
          }.png`,
        }}
      />
      <OptimizeTag />
      <LpTemplate inviter={inviter} isMissionUpdated={isMissionUpdated} />
    </>
  );
};

export default LpPage;
